import { useTranslation } from 'react-i18next'
import useAvailableBalance from '../../hooks/useAvailableBalance'
import BaseBalanceCard from './BaseBalanceCard'

const AvailableBalanceCard = () => {
  const { t } = useTranslation('wallet', { keyPrefix: 'assetCard' })

  const {
    goldBalanceInUsd,
    rwaBalanceInUsd,
    cryptoBalanceInUsd,
    totalBalanceInUsd,
    loading,
  } = useAvailableBalance()

  return (
    <BaseBalanceCard
      loading={loading}
      title={t('available')}
      goldBalanceInUsd={goldBalanceInUsd}
      rwaBalanceInUsd={rwaBalanceInUsd}
      cryptoBalanceInUsd={cryptoBalanceInUsd}
      totalBalanceInUsd={totalBalanceInUsd}
    />
  )
}

export default AvailableBalanceCard
